module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_c('i', [_vm._v("Foreword")]), _vm._v(" by Charles Marsh")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt001"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(":"), _c('br'), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLORING")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONHOEFFER")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECEPTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Man, the Myth, the Battle")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Rorschach Test: American Bonhoeffers from Cox to Koehn")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical Patriot")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteous Gentile")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moral Hero")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Gradual Embrace: The Evangelical Bonhoeffer before Metaxas")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Reservations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonhoeffer’s Triumph in the Evangelical Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch3s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Multifaceted Bonhoeffer")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(":"), _c('br'), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONHOEFFER AND")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMEGROWN")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Bonhoeffer, Bush, and the “War on Terror”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch4s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hawk or Dove?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch4s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Professional Scholars Weigh In")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch4s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bush Becomes Hitler . . . Sort Of")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Bonhoeffer, Obama, and the “Culture of Death”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appropriating the German Church Struggle")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revisiting the American Holocaust")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Updating the Nazi Analogy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch5s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Metaxas Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Metaxas Phenomenon")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bonhoeffer Biography for the Age of Obama")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocb",
    attrs: {
      "id": "ch6s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Game")]), _vm._v("-"), _c('i', [_vm._v("Changer")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Closer Look")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Fifty Years” of Misappropriation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scholarly Backlash")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evangelical Reservations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Metaxas Agenda")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch6s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaxas’s Bonhoeffer in Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(":"), _c('br'), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIUMPH OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPULIST")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONHOEFFER")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_c('i', [_vm._v("Kairos")]), _vm._v(": “A Bonhoeffer Moment in America”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Southern Baptists Have Their Bonhoeffer Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Backgrounds of the Bonhoeffer Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bonhoeffer Moment Arrives . . . Sort Of")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch7s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Different Sort of Bonhoeffer Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Surprise: Bonhoeffer Gets Trumped")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trump Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonhoeffer and the 2016 Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaxas Doubles Down")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch8s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pushback")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Aftermath: A “Bonhoeffer Moment” for Liberals")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Left Has Its Bonhoeffer Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonhoeffer Scholars Seize Their Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evangelicals Join the Revolt")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searching for Solid Ground")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch9s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outrage Becomes Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Battle for Bonhoeffer, circa 2018")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTSCRIPT")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "ch11s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Bonhoeffer Moment: An Open Letter to Christians Who Love Bonhoeffer and (Still) Support Trump")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0